export interface Config {
    baseURL: string;
    appVersion: string;
    externalAccountsProviders: {
        vituity: string;
    };
}

export const config: Config = {
    baseURL: "https://localhost:44338",
    appVersion: "1.48.2",
    externalAccountsProviders: {
        vituity: "Okta",
    },
};

export const loadConfig = async () => {
    if (process.env.NODE_ENV !== "development") {
        config.baseURL = null
        try {
            const response = await fetch('/config.json');

            if (!response.ok) {
                throw new Error(`Could not set base URL`);
            }

            const json = await response.json();
            config.baseURL = json.baseURL || process.env.REACT_APP_API_BASE_URL;
        } catch (error) {
            console.error("Could not set base URL");
        }
    }
};